import { translate } from '../../../../Internationalization';
import React from 'react';

/** @extends {React.Component<>} */
export default class GenericMoversOverlay extends React.Component {
	/** @returns {string} */
	static #getTenant() {
		const host = window.location.hostname.toLowerCase();
		if (host.includes('simplyhome')) {
			return translate('global.tenants.simplyhome');
		}
		return translate('global.tenants.homekeepr'); // safe default
	}

	/**
	 * @returns {JSX.Element}
	 */
	/* eslint-disable class-methods-use-this -- Render method must be invokable by `this` */
	render() {
		return (
			<section className="md:flex justify-between mt-2">
				<article className="mr-4">
					<p className="h-ms-4">
						{translate(
							'agent.pages.dashboard.movers.labels.likely'
						)}
					</p>
					<p
						className="text-sm mt-2"
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={{
							__html: translate(
								'agent.pages.dashboard.movers.upgraded.likely_description',
								GenericMoversOverlay.#getTenant()
							),
						}}
					/>
				</article>
			</section>
		);
	}
}
